"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CountyAdminPage = void 0;
const DataTable_1 = require("@juvare/common-data-table-ui/DataTable");
const shared_1 = require("../../../../backend/features/default-classifiers/shared");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const react_1 = __importDefault(require("react"));
const classifiers_1 = require("../../classifiers");
const storageClientFilter = [{ column: 'type', op: '=', value: 'county' }];
function getEntityTitle(row) {
    return row.columns.name;
}
const EntityDetailsComponent = (props) => {
    var _a, _b;
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    return (react_1.default.createElement(classifiers_1.SlideoutFields, { fields: [
            { label: t('common.status'), value: t(`classifiers.statusEnum.${props.response.data.status}`) },
            { label: t('defaultClassifiers.fips'), value: (_a = props.response.data.fips) !== null && _a !== void 0 ? _a : '' },
            { label: t('defaultClassifiers.state'), value: (_b = props.response.columns.parentName) !== null && _b !== void 0 ? _b : '' },
        ] }));
};
const CountyAdminPage = () => {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const formConfig = (0, classifiers_1.useDefaultFormConfig)({ hideName: true });
    return (react_1.default.createElement(classifiers_1.ClassifierAdminPage, { entity: shared_1.jurisdictionEntityName, storageClientFilter: storageClientFilter, title: t('defaultClassifiers.county'), tableColumns: [
            {
                headerLabel: t('common.name'),
                sortKey: 'name',
                cellFunction: (row) => {
                    if (row.columns.parentName) {
                        return react_1.default.createElement(DataTable_1.TextCell, null, row.columns.name + ' (' + row.columns.parentName + ')');
                    }
                    else {
                        return react_1.default.createElement(DataTable_1.TextCell, null, row.columns.name);
                    }
                },
            },
            {
                headerLabel: t('common.status'),
                sortKey: 'status',
                cellFunction: (row) => react_1.default.createElement(DataTable_1.TextCell, null, t(`classifiers.statusEnum.${row.columns.status}`)),
            },
        ], fullTextSearchField: 'search', buildFilter: (builder) => {
            builder.quickSearchFilter({
                dataPath: 'fips',
                label: t('defaultClassifiers.fips'),
                sx: { flex: { xs: '1 1 0', lg: '1 1 0', xl: '1 1 0' } },
            });
            builder.quickFilterSelect({
                dataPath: 'parentPostalCode',
                label: t('defaultClassifiers.state'),
                valueProviderType: 'classifier.state',
                widget: 'form.select',
            });
        }, mapFilter: (filterData) => {
            const filters = [];
            if (filterData.fips) {
                filters.push({ column: 'fips', op: '=', value: filterData.fips });
            }
            if (filterData.parentPostalCode) {
                filters.push({ column: 'parentPostalCode', op: '=', value: filterData.parentPostalCode });
            }
            return filters;
        }, getEntityTitle: getEntityTitle, entityDetailsComponent: EntityDetailsComponent, hideCreate: true, partialUpdate: true, formConfig: formConfig }));
};
exports.CountyAdminPage = CountyAdminPage;
